import React, { useCallback, useEffect, useState } from "react";
import Col from "react-bootstrap/esm/Col";
import Row from "react-bootstrap/esm/Row";
import { toast } from "react-toastify";
import styled from "styled-components";
import api from "../../../../../api";
import Colors from "../../../../../assets/styles/Colors";
import Button from "../../../../../components/Button";
import Input from "../../../../../components/Input";
import Loader from "../../../../../components/Loader";
import Message from "../../../../../components/Message";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../../../store";
import { AppState } from "../../../../../store/appSlice";
//
//
const AdminTplPriceTabFour: React.FC<{ productId: number | undefined }> = ({
  productId,
}) => {
  //
  const { t } = useTranslation()
  // 
  const { field_Language } = useAppSelector(
    (data: { app: AppState }) => data.app
  );
  // 
  const {
    data: tplPackagePrices,
    isLoading: isTplPackagePricesLoading,
    refetch: isRefetchPackagePrice,
  } = api.useGetTplPackagePricesQuery(productId as number, {
    skip: productId ? false : true,
  });
  //
  //
  const [prices, setPrices] = useState<
    { price: number | null; id: number }[] | undefined
  >(undefined);
  //
  //
  const updatePriceById = (id: number, newPrice: number) => {
    const updatedPrices = prices?.map((item) => {
      if (item.id === id) {
        return { ...item, price: newPrice };
      }
      return item;
    });

    setPrices(updatedPrices);
  };
  //
  //
  const [updatePackagePrice, { isLoading: isUpdatePackagePriceLoading }] =
    api.useUpdateTplPackagePriceByIdMutation();
  //
  //
  const UpdatePackagePrice = async (id: number, price: string) => {
    //
    if (id && price) {
      try {
        await updatePackagePrice({
          priceId: id,
          premium: parseFloat(price),
        }).unwrap();
        //
        // refetch price
        isRefetchPackagePrice();
        //
        toast.success(`${t('price')} ${t('updatedSuccessfully')}`);
        //
        //
      } catch (error) {
        if (error?.data?.errors?.constructor === Array) {
          const firstError = error.data.errors[0];
          const errorMessage = firstError.message;
          toast.error(errorMessage);
        } else {
          toast.error(`${t('errorOccurred')}`);
        }
      }
    } else {
      toast.info(`${t('enterPrice')}`);
    }
    //
  };
  //
  //
  const setIncomePrices = useCallback(() => {
    //
    if (tplPackagePrices && tplPackagePrices.length >= 1) {
      setPrices(
        tplPackagePrices?.map((x) => ({
          price: x.premium,
          id: x.id,
        }))
      );
    }
    //
  }, [tplPackagePrices]);
  //
  //
  useEffect(() => {
    setIncomePrices();
    //
    return () => {};
  }, [setIncomePrices]);

  //
  //
  const MainLoading = isUpdatePackagePriceLoading || isTplPackagePricesLoading;
  //
  //
  return MainLoading ? (
    <Loader />
  ) : (
    <Wrapper>
      <Message
        variant="light-red"
        text={
          t('tplPricesMandatory')
        }
      />

      <hr />

      {tplPackagePrices && tplPackagePrices.length <= 0 && (
        <h4
          style={{
            textAlign: "center",
            color: Colors.primaryRed,
          }}
        >
          {t('generatedPricesNotFound')}
        </h4>
      )}

      {tplPackagePrices && tplPackagePrices.length >= 1 ? (
        <>
          <Row>
            <Col xs={{ span: 4 }}>
              <label htmlFor="package-name">{t('packageTitle')}</label>
            </Col>
            <Col xs={{ span: 2 }}>
              <label htmlFor="limit-name">{t('limit')}</label>
            </Col>
            <Col xs={{ span: 1 }}>
              <label htmlFor="currency-name">{t('currency')}</label>
            </Col>
            <Col xs={{ span: 2 }}>
              <label htmlFor="payment-method">{t('paymentType')}</label>
            </Col>
            <Col xs={{ span: 3 }}>
              <label htmlFor="price-to-currency">{t('priceByCurrency')}</label>
            </Col>
          </Row>

          <hr />
          {tplPackagePrices?.map((item, index) => {
            if (item && item.limit !== null) {
              return (
                <Row
                  key={index}
                  style={{
                    marginBottom: "15px",
                  }}
                >
                  <Col xs={{ span: 4 }}>
                    <Input
                      id="package-name"
                      name="package-name"
                      label={``}
                      type="text"
                      placeholder={``}
                      value={item?.tplPackage?.mainPackage?.translations[field_Language]?.title}
                      onChange={(value) => {}}
                      width={"fullWidth"}
                      disabled={true}
                    />
                  </Col>

                  <Col xs={{ span: 2 }}>
                    <Input
                      id="limit-name"
                      name="limit-name"
                      label={``}
                      type="text"
                      placeholder=""
                      // @ts-ignore
                      value={item?.limit?.value}
                      onChange={(value) => {}}
                      width={"fullWidth"}
                      disabled={true}
                    />
                  </Col>

                  <Col xs={{ span: 1 }}>
                    <Input
                      id="currency-name"
                      name="currency-name"
                      label={``}
                      type="text"
                      placeholder=""
                      value={item?.currency?.currencyCode}
                      onChange={(value) => {}}
                      width={"fullWidth"}
                      disabled={true}
                    />
                  </Col>

                  <Col xs={{ span: 2 }}>
                    <Input
                      id="payment-method"
                      name="payment-method"
                      label={``}
                      type="text"
                      placeholder=""
                      value={item?.paymentScheduleType?.translations[field_Language]?.title}
                      onChange={(value) => {}}
                      width={"fullWidth"}
                      disabled={true}
                    />
                  </Col>

                  <Col xs={{ span: 1 }}>
                    <Input
                      id="price-to-currency"
                      name="price-to-currency"
                      label={``}
                      type="number"
                      placeholder=""
                      value={prices?.find((x) => x.id === item.id)?.price || ""}
                      onChange={(value) => updatePriceById(item.id, value)}
                      width={"fullWidth"}
                    />
                  </Col>

                  <Col xs={{ span: 2 }}>
                    <Button
                      style={{
                        minWidth: "unset",
                      }}
                      disabled={
                        prices?.find((x) => x.id === item.id)?.price ===
                        item.premium
                          ? true
                          : false
                      }
                      text={t('save')}
                      onClick={() => {
                        UpdatePackagePrice(
                          item.id,
                          prices?.find((x) => x.id === item.id)
                            ?.price as unknown as string
                        );
                      }}
                      btnStyleType={"primary"}
                      border={false}
                      fullWidth={true}
                    />
                  </Col>
                </Row>
              );
            } else {
              return null;
            }
          })}
        </>
      ) : null}
    </Wrapper>
  );
};
//
const Wrapper = styled.div`
  padding: 10px;
`;
//
export default AdminTplPriceTabFour;
